"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgMegaphoneOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M28 25.39V3.61L14.84 8H8.5a5 5 0 00-3.62 1.09C3.65 10.13 3 12 3 14.5s.65 4.38 1.88 5.42a4.19 4.19 0 002.22 1 15.05 15.05 0 003.15 7.75l.3.34h4.58l-1-8h.71zm-2-2.78l-10-3.33V9.72l10-3.33zM5 14.5c0-1.86.42-3.24 1.17-3.88.45-.37.83-.62 2.33-.62H14v9H8.5c-1.5 0-1.89-.24-2.33-.61C5.42 17.76 5 16.37 5 14.5zM12.87 27h-1.38a13.39 13.39 0 01-2.37-6h3z" })));
}
exports.default = SvgMegaphoneOutline;
//# sourceMappingURL=MegaphoneOutline.js.map